import { render, staticRenderFns } from "./authInfoDialog.vue?vue&type=template&id=2345efd4&scoped=true&"
import script from "./authInfoDialog.vue?vue&type=script&lang=js&"
export * from "./authInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./authInfoDialog.vue?vue&type=style&index=0&id=2345efd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345efd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2345efd4')) {
      api.createRecord('2345efd4', component.options)
    } else {
      api.reload('2345efd4', component.options)
    }
    module.hot.accept("./authInfoDialog.vue?vue&type=template&id=2345efd4&scoped=true&", function () {
      api.rerender('2345efd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotOrder/userGiftOrder/dialog/authInfoDialog.vue"
export default component.exports